import {
  SET_GIA_ITEMS,
  CHANGE_GIA_ITEM,
  BLUR_GIA_ITEM,
  REQUEST_APPEAL_SUCCESS,
  LOAD_DRAFT_EMPTY
} from '../constants';

const initialState = {
  items: [],
  blur: {
    registration_code: false,
    document_number: false
  },
  registration_code: {
    value: '',
    invalidMessage: ''
  },
  document_number: {
    value: '',
    invalidMessage: ''
  }
};

const gia = (state = initialState, action) => {
  switch (action.type) {
    case SET_GIA_ITEMS:
      return {
        ...state,
        items: action.payload
      };
    case CHANGE_GIA_ITEM:
      return {
        ...state,
        ...action.payload,
        blur: {
          ...state.blur,
          [action.payload.field]: false
        }
      };
    case BLUR_GIA_ITEM:
      if (Array.isArray(action.payload)) {
        return {
          ...state,
          blur: {
            ...state.blur,
            [action.payload[0]]: true,
            [action.payload[1]]: true
          }
        };
      }
      return {
        ...state,
        blur: {
          ...state.blur,
          [action.payload]: true
        }
      };
    case REQUEST_APPEAL_SUCCESS:
      return {
        ...state,
        registration_code: initialState.registration_code,
        document_number: initialState.document_number
      };
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default gia;
